var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import TabTrap from 'syf-component-library/helpers/TabTrap';
import { CLICK_TRACKING_EVENT } from '../../../const/analytics';
import { CustomButton, Icon, SuccessModalBodyWrapper, SuccessModalImageWrapper, SuccessModalTitleWrapper, SuccessModalWrapper, SuceessBannerFooter } from './subcomponents';
import { useButtonAnalytics } from '../../customHooks';
import AriaLiveRegion from '../../templates/AriaLiveRegion';
import { FAL_CHECK_CIRCLE } from '../../../const/iconProps';
var SuccessModal = function (_a) {
    var closeModal = _a.closeModal, currentAlertData = _a.currentAlertData, alertFormData = _a.alertFormData, _b = _a.hasConsentBanner, hasConsentBanner = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var ALERT_SUCCESS_TITLE_I18N = t('successModal.title');
    var ALERT_SUCCESS_CONTENT_I18N = t('successModal.content');
    var CLOSE_I18N = t('successModal.closeSuccessModal');
    var ADA_TEXT_SUCCESS_BANNER_I18N = t('adaHelperText.successBanner');
    var alertName = useButtonAnalytics(currentAlertData, alertFormData, hasConsentBanner).alertName;
    return (_jsxs(TabTrap, { children: [_jsx(AriaLiveRegion, { children: ADA_TEXT_SUCCESS_BANNER_I18N }), _jsxs(SuccessModalWrapper, __assign({ "data-test": "SuccessModalWrapper" }, { children: [_jsx(SuccessModalImageWrapper, __assign({ "data-test": "SuccessModalImageWrapper" }, { children: _jsx(Icon, { icon: FAL_CHECK_CIRCLE }) })), _jsx(SuccessModalTitleWrapper, { children: ALERT_SUCCESS_TITLE_I18N }), _jsx(SuccessModalBodyWrapper, __assign({ "data-test": "SuccessModalBodyWrapper" }, { children: ALERT_SUCCESS_CONTENT_I18N })), _jsx(SuceessBannerFooter, { children: _jsx(CustomButton, __assign({ "data-test": "ButtonCloseModal", buttonType: "primary", className: "ensightenalertevent", onClick: closeModal, "data-reason": "micro-alert:confirmation:".concat(alertName, ":close"), "data-analytics": CLICK_TRACKING_EVENT }, { children: CLOSE_I18N })) })] }))] }));
};
export default SuccessModal;
